'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _ModalContainer = require('../ModalContainer');

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _windowPropType = require('../PropTypes/windowPropType');

var _windowPropType2 = _interopRequireDefault(_windowPropType);

var _userPropType = require('../PropTypes/userPropType');

var _userPropType2 = _interopRequireDefault(_userPropType);

var _getSignInHref = require('../helpers/getSignInHref');

var _getSignInHref2 = _interopRequireDefault(_getSignInHref);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description The PromotionModal component is used for showing modals related to promotions
 * (ie: free premium weekend) and rendering content returned from backplane relevant to the
 * current promotion.
 *
 * @param {object} props
 * @param {boolean} props.isOpen boolean flag determining whether or not show the modal
 * @param {string} props.header Header text for the modal
 * @param {string} props.sponsorName Name of the sponsor for the current promotion
 * @param {object} props.imageUrls Urls for the image and retina images
 * @param {function} props.onClose Function that is called upon closing the modal
 * @param {string} props.description Optional prop for a description string for the promotion
 */
var PromotionModal = function (_Component) {
  (0, _inherits3.default)(PromotionModal, _Component);

  function PromotionModal() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PromotionModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PromotionModal.__proto__ || (0, _getPrototypeOf2.default)(PromotionModal)).call.apply(_ref, [this].concat(args))), _this), _this.getSrcSetString = function (sizes) {
      var imageUrls = _this.props.imageUrls;


      var srcSetStrings = sizes.map(function (size) {
        return _this.props.imageUrls[size] ? imageUrls[size] + ' ' + size : null;
      });

      return srcSetStrings.filter(function (value) {
        return !!value;
      }).join(', ');
    }, _this.getSignInUrl = function () {
      var window = _this.props.window;

      return (0, _getSignInHref2.default)(window ? window.location.href : null);
    }, _this.signInClick = function () {
      var window = _this.props.window;

      window.analytics.track('Clicked Link', {
        linkLocation: 'premium open house',
        linkName: 'sign in'
      });
    }, _this.signUpClick = function () {
      var window = _this.props.window;

      window.analytics.track('Clicked Link', {
        linkLocation: 'premium open house',
        linkName: 'sign up'
      });

      window.location.assign('/create-account');
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /**
   * @description Method used to dynamically extract responsive image sizes
   * and concatenate the URL's into a valid string for the srcSet attribute
   * @param {Array<string>} sizes The imageUrl image size keys to extract (2x, 3x, etc...)
   */


  (0, _createClass3.default)(PromotionModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onClose = _props.onClose,
          header = _props.header,
          sponsorName = _props.sponsorName,
          isOpen = _props.isOpen,
          imageUrls = _props.imageUrls,
          description = _props.description,
          userDetails = _props.userDetails;


      return _react2.default.createElement(
        _ModalContainer2.default,
        {
          onClose: onClose,
          contentLabel: sponsorName + ' Premium Open House',
          isOpen: isOpen
        },
        _react2.default.createElement(
          'div',
          { className: 'quiver-promotion-modal' },
          _react2.default.createElement(
            'div',
            { className: 'quiver-promotion-modal__header' },
            _react2.default.createElement(
              'h4',
              null,
              header
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'quiver-promotion-modal__image' },
            _react2.default.createElement('img', {
              role: 'presentation',
              src: imageUrls['1x'],
              srcSet: this.getSrcSetString(['2x', '3x'])
            })
          ),
          description && _react2.default.createElement(
            'p',
            { className: 'quiver-promotion-modal__description' },
            description
          ),
          userDetails ? _react2.default.createElement(
            'div',
            { className: 'quiver-promotion-modal__cta' },
            _react2.default.createElement(
              _Button2.default,
              { onClick: onClose },
              'Got it, thanks'
            )
          ) : _react2.default.createElement(
            'div',
            { className: 'quiver-promotion-modal__cta' },
            _react2.default.createElement(
              _Button2.default,
              { onClick: this.signUpClick },
              'Sign Up'
            ),
            _react2.default.createElement(
              'span',
              { className: 'quiver-promotion-modal__cta--sign-in' },
              'Already have an acccount?',
              ' ',
              _react2.default.createElement(
                'a',
                { onClick: this.signInClick, href: this.getSignInUrl() },
                'Sign In'
              )
            )
          )
        )
      );
    }
  }]);
  return PromotionModal;
}(_react.Component);

PromotionModal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  header: _propTypes2.default.string.isRequired,
  sponsorName: _propTypes2.default.string.isRequired,
  imageUrls: _propTypes2.default.shape({
    '1x': _propTypes2.default.string.isRequired,
    '2x': _propTypes2.default.string,
    '3x': _propTypes2.default.string
  }).isRequired,
  onClose: _propTypes2.default.func,
  description: _propTypes2.default.string,
  window: _windowPropType2.default,
  userDetails: _userPropType2.default
};
PromotionModal.defaultProps = {
  onClose: null,
  description: null,
  userDetails: null };
exports.default = PromotionModal;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PromotionModal/PromotionModal.js
// module id = 631
// module chunks = 11